module.exports = __webpack_public_path__ + "static/media/PetAllergy – 1.8372165a.jpg";